@if (form) {
	@let isBuy = form.get('side')?.value === orderSideEnum.BUY;

	<form
		[formGroup]="form"
		(ngSubmit)="onSubmit()"
		class="create-order-option dropdown-content-root"
	>
		<div class="dropdown-title">
			<h3 class="title">{{ formattedOptionContractTicker() }}</h3>
			<tui-icon
				class="close-icon"
				icon="@tui.x"
				(click)="onCloseDropdown()"
			/>
		</div>

		<div class="wrapper">
			<app-trade-side-toggle
				[side]="form.get('side')?.value"
				(sideChange)="toggleOrderSide($event)"
			/>

			<div class="form">
				<app-order-type-select
					[types]="orderTypes"
					[control]="form.get('type')"
				/>

				@if (form.get('type')?.value !== orderTypeEnum.MARKET) {
					<app-order-price-input
						label="optionsCreateOrder.price"
						[control]="form.get('limit_price')"
						[bidPrice]="optionContract()?.last_quote?.bid ?? null"
						[askPrice]="optionContract()?.last_quote?.ask ?? null"
						[isLoading]="isLoadingCreate()"
					/>
				}

				<app-order-qty-input [control]="form.get('qty')" />

				<app-order-term-select
					[terms]="orderTerms"
					[control]="form.get('time_in_force')"
				/>
			</div>

			<div class="order-summary">
				<div class="item">
					<p class="label">{{ 'optionsCreateOrder.amount' | translate }}:</p>
					<span class="value">{{ approximateSum() | price }}</span>
				</div>
				<div class="item">
					<p class="label">{{ 'optionsCreateOrder.availableFunds' | translate }}:</p>
					<span class="value">{{ alpacaAccount()?.buying_power ?? 0 | price }}</span>
				</div>
			</div>

			@if ((isBuy && !canBuy()) || (!isBuy && !canSell())) {
				<div class="no-access">
					<div class="no-access-left">
						<tui-icon
							class="lock-icon"
							icon="@tui.lock"
						/>
					</div>

					<div class="no-access-right">
						<p class="no-access-text">
							{{ 'optionsCreateOrder.tradingNotAllowed' | translate }}
						</p>
						<app-button
							appearance="flat"
							size="s"
							iconStart="circle-question-mark"
							tuiDropdownHover
							[tuiDropdown]="dropdownTradingNotAllowed"
						/>
					</div>
				</div>
			}

			<div class="action">
				<app-button
					[appearance]="isBuy ? 'positive' : 'negative'"
					size="l"
					type="submit"
					[isLoading]="isLoadingCreate()"
					[isDisabled]="isInvalidOrder"
				>
					{{ (isBuy ? 'optionsCreateOrder.buy' : 'optionsCreateOrder.sell') | translate }}
				</app-button>
			</div>
		</div>
	</form>
}

<ng-template #dropdownTradingNotAllowed>
	<div
		class="dropdown-trading-not-allowed"
		appClickOutside
	>
		<h5 class="title">{{ 'optionsCreateOrder.whyUnavailable' | translate }}</h5>
		<p class="descr">{{ 'optionsCreateOrder.possibleReasons' | translate }}</p>

		<div class="items">
			@for (reason of reasonsTradingOption; track reason) {
				<div class="item">
					<img
						class="danger-icon"
						src="/images/icons/list-danger.svg"
					/>
					<p class="text">{{ 'optionsCreateOrder.' + reason | translate }}</p>
				</div>
			}
		</div>

		<div class="support">
			<p class="descr">{{ 'optionsCreateOrder.contactSupport' | translate }}</p>
			<div class="links">
				<a
					class="link"
					target="_blank"
					[href]="'https://wa.me/' + supportByLang?.whatsapp"
				>
					<img
						class="icon"
						src="/images/icons/whatsapp.svg"
					/>
					<p class="text">{{ 'optionsCreateOrder.whatsapp' | translate }}</p>
				</a>
				<a
					class="link"
					[href]="'mailto:' + supportByLang?.email"
				>
					<img
						class="icon"
						src="/images/icons/email.svg"
					/>
					<p class="text">{{ 'optionsCreateOrder.email' | translate }}</p>
				</a>
			</div>
		</div>
	</div>
</ng-template>
